export const hospitalMotherColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'medical_record_number',
  'name__first_name',
  'name__last_name',
  'name__middle_name',
  'name__name_prefix',
  'name__name_string',
  'name__name_suffix',
  'patient_id',
  'snapshot_id',
];
